import React from 'react';
import { useEffect, useRef } from 'react';

export default function AutoResizeTextarea({ value, onChange, placeholder, ...props }) {
  const ref: React.RefObject<HTMLTextAreaElement> = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;

    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  };

  const handleInput = (e) => {
    resize();
    onChange(e);
  };

  useEffect(() => {
    resize();
  }, [value]);

  return (
    <textarea
      {...props}
      ref={ref}
      value={value}
      onChange={handleInput}
      placeholder={placeholder}
      style={{ overflow: 'hidden', resize: 'none' }}
    />
  );
}
